<div class="component-container">
    <table-panel header="Regały" class="flex flex-grow"
                 newOneTitle="Nowy regał" (createNewOne)="createNew()"
                 [compTableFlag]="false">
        <pr-new-table
            panel-body
            class="flex flex-grow"
            [dataService]="storesService"
            [columnsData]="columnsData"
            [tableId]="tableId"
            [navigationArr]="navigateLinkArr"
            [canNavigate]="true"
            [sortBy]="sortBy"
            [dataServiceMethod]="'fetchShelvesOdata'"
        >
        </pr-new-table>
    </table-panel>
</div>
